/**
 * Marketing & Tracking Configuration
 * 
 * SETUP INSTRUCTIONS:
 * 
 * 1. FACEBOOK PIXEL:
 *    - Go to: https://business.facebook.com/events_manager
 *    - Create a new pixel or copy your existing Pixel ID
 *    - Replace 'YOUR_FACEBOOK_PIXEL_ID' below
 * 
 * 2. GOOGLE ANALYTICS:
 *    - Go to: https://analytics.google.com
 *    - Create a GA4 property
 *    - Copy your Measurement ID (format: G-XXXXXXXXXX)
 *    - Replace 'YOUR_GA_MEASUREMENT_ID' below
 * 
 * 3. UTM PARAMETERS (for Instagram ads):
 *    When creating your Instagram ad, use this URL format:
 *    https://yourwebsite.com?utm_source=instagram&utm_medium=cpc&utm_campaign=25euro_promo
 */

const config = {
  // Facebook/Meta Pixel ID (for Instagram ad tracking)
  facebookPixelId: process.env.REACT_APP_FACEBOOK_PIXEL_ID || 'YOUR_FACEBOOK_PIXEL_ID',
  
  // Google Analytics Measurement ID
  googleAnalyticsId: process.env.REACT_APP_GOOGLE_ANALYTICS_ID || 'YOUR_GA_MEASUREMENT_ID',
  
  // Enable/disable tracking (useful for development)
  enableTracking: process.env.NODE_ENV === 'production', // Only track in production
  
  // Your website URL
  websiteUrl: process.env.REACT_APP_WEBSITE_URL || 'https://stu-studios.de/promo',
};

export default config;

